import { Injectable } from '@angular/core';
import { WorkflowBaseApi } from 'cad/common/services/api/workflow/workflow-base/workflow-base';

@Injectable()
export class ScheduleAndViewWorkflowApi extends WorkflowBaseApi { }
